

const Error =()=>{
    return (
        <div>
            <h1>OOps !!!!!!!</h1>
            <h2>Something Went Wrong </h2>
        </div>
    );
}


export default Error;